import React from 'react';
import redial from 'redial';
import {withLegacyProviders} from '../LegacyComponentWrapper';

import Page from '@aboutyou/legacy-desktop/src/app/pages/SeoStreamPage/SeoStreamPage';
import redialHandle from '@aboutyou/legacy-desktop/src/app/pages/SeoStreamPage/redial';
import {LegacyDesktopStyles} from '../styles/LegacyBaseStyles';

const PageWithRedial = redial.provideHooks(redialHandle)(Page);

const LegacyPage = withLegacyProviders(PageWithRedial);

export const SeoStreamPage = () => {
  return (
    <>
      <div className={LegacyDesktopStyles} />
      <LegacyPage />
    </>
  );
};
